function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCadIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 650 650",
    style: {
      enableBackground: "new 0 0 650 650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M460.813,248.178c-34.41-116.23-136.39-188.43-227.87-161.43s-137.78,143.15-103.41,259.38 s136.4,188.53,227.87,161.48S495.174,364.407,460.813,248.178z M348.684,487.278c-85.03,25.14-180.1-42.87-212.34-151.9 s10.56-217.8,95.59-242.95c85.03-25.15,180.1,42.87,212.34,151.9C476.513,353.328,433.714,462.138,348.684,487.278z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "210.454,241.578 221.064,259.538 230.605,255.128 226.274,285.628 239.855,273.078  245.735,279.878 259.435,277.378 256.023,296.997 263.814,297.918 234.735,324.288 239.185,331.958 211.985,327.208  212.524,353.128 210.454,353.128 208.394,353.128 208.935,327.208 181.735,331.958 186.185,324.288 157.105,297.918  164.894,296.997 161.485,277.378 175.185,279.878 181.064,273.078 194.644,285.628 190.314,255.128 199.855,259.538  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M384.214,344.747c-0.019,0.198-0.003,0.398,0.05,0.59c0.197,0.568,0.282,1.169,0.25,1.77"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M384.523,345.228c0,0.45,0.07,0.89,0.08,1.33"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M384.404,344.978c0,0.63,0.06,1.25,0.06,1.88"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M384.234,344.918c0,0.4,0.24,0.74,0.26,1.14c-0.06,0.374-0.06,0.756,0,1.13"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M386.104,379.497c0,0,4.71-23.38-2.26-46.83c-5.05-17-16.22-34-39.74-42.17 c0,0-45.25-22.74-26.58-84.83c0,0,22.58-56.67,58.83-66.67c0,0-82,4-89.5,129.5c0,0-5.5,0-6.75-9c0,0-9.62-13-9.62,9.62 c0.287,8.375,1.758,16.667,4.37,24.63c0,0,2.25,5.25,0,23.25c0,0-9,32.75,17.5,28.5c0,0,4.83,57.5,22.83,78.5 c0,0,30.48,44.56,57.77,53.11l3.53-2c0,0-62.3-33.1-67.3-103.77c0,0-5-40.66,6.67-59.33s38.75-14.5,51.5-1.75 c5.086,7.459,9.471,15.373,13.1,23.64C381.264,335.747,386.174,356.747,386.104,379.497z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CH_Path",
    style: {
      fill: "#FFFFFF"
    },
    d: "M381.484,332.158c0.32,2.14,3.56,7.77,3,9.49c-2.63-6.08-8.05-9.94-10.73-10.3 c-34.23-0.82-38.81-7.64-40.49-9.48c5.79,6.95,38.77,5.8,41.31,5.71h1.37C378.604,327.747,381.484,332.158,381.484,332.158z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CH_Path-2",
    style: {
      fill: "#FFFFFF"
    },
    d: "M308.305,77.418c-3.82-3.55-43.28-47.67-74.9-40.33 c-18.35,4.27-28.7,41.51-30.79,67.3c-5.47,67.48,6.81,131,6.81,131h-4.9c0,0-14.71-69.47-8.18-131.59 c0.13-1.21,0.82-10.9,0.82-10.9s5.18-50.49,31.33-63.47C260.044,13.748,306.404,73.328,308.305,77.418z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CH_Path-3",
    style: {
      fill: "#FFFFFF"
    },
    d: "M477.805,188.678c44.61-9.3,76.2-6.78,85.11,9.81 c18.99,35.36-72.14,121.26-203.51,191.81s-253.33,99.13-272.32,63.77c-10.27-19.12,11.68-53,54.8-91.3l-0.08,0.63 c-32.79,32.28-48.4,60.64-39.22,77.73c18.78,35,134.22,9.48,257.84-56.91s208.58-148.57,189.8-183.53 c-8.2-15.27-34.73-17.23-72.42-11.08C477.164,189.748,476.904,188.838,477.805,188.678z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CH_Path-4",
    style: {
      fill: "#FFFFFF"
    },
    d: "M230.855,348.568c14.89,57,57.75,144.21,65.38,157.65s54.12,94.81,96.26,93.36 s41-82.46,41.41-94.45s0-40.76-1.09-44.86l2.35-2.8c0,0,3.31,38.23,3.83,47.3c2.18,38.5-5.81,117.69-42.14,118.42 c-52.31,1-97.71-97-106.07-113.7c-5.89-11.78-30.87-49-65-160.19L230.855,348.568z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadIconWhite);
export default __webpack_public_path__ + "static/media/cad-icon-white.d87b1ea4851e11a5421d2c8f4307cb63.svg";
export { ForwardRef as ReactComponent };